<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-form ref="form" @submit.prevent="vincular()">
      <v-card class="elevation-0" :disabled="loading">
        <v-toolbar :color="this.getAppBarColor" dark>Vincular Usuario</v-toolbar>
        <v-card-text>
          <SelectEmpresa
            label="Empresa Principal"
            prepend-icon="mdi-domain"
            :multiple="false"
            :empresasSelecionadas="usuario.empresaPrincipal"
            @onChanged="usuario.empresaPrincipal = $event"
          />
          <v-autocomplete
            v-model="usuario.grupoPrincipal"
            label="Grupo Principal"
            :items="grupos"
            item-text="id"
            item-value="id"
            prepend-icon="mdi-select-group"
            :rules="[rules.required]"
          />
          <v-autocomplete
            v-model="usuario.papel"
            label="Papel"
            :items="papeis"
            item-text="nome"
            item-value="id"
            prepend-icon="mdi-shield-key"
            :rules="[rules.required]"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-3 pl-5 pr-5"
            color="blue darken-1"
            type="submit"
            outlined
            small
            dark
            rounded
            depressed
            :loading="loading"
          >
            <v-icon left>mdi-content-save</v-icon>Salvar
          </v-btn>

          <v-btn
            class="ma-3 pl-5 pr-5"
            color="red darken-2"
            type="button"
            outlined
            small
            dark
            rounded
            depressed
            @click="hide()"
          >
            <v-icon left>mdi-close</v-icon>Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Usuarios from '@/services/usuarios'
import Papeis from '@/services/papeis'
import Grupos from '@/services/grupos'
import Colaboradores from '@/services/colaboradores'
import rules from '@/utils/rules'

export default {
  name: 'DialogVincularUsuario',

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      dialog: false,
      loading: false,
      rules: rules,

      usuario: new Object(),
      papeis: [],
      grupos: []
    }
  },

  methods: {
    async show(usuario) {
      this.loading = true
      this.dialog = true
      this.usuario = usuario

      try
      {
        if(!this.usuario.papel)
        {
          let colaborador = await new Colaboradores().getById(usuario.cpf)
          if(colaborador) this.usuario.papel = colaborador.papel || ''
        }
      }
      finally
      {
        this.loading = false
      }
    },

    hide() {
      this.dialog = false
      this.usuario = new Object()
    },

    async vincular() {
      if(!this.$refs.form.validate()) return

      try
      {
        this.loading = true
        await new Usuarios().updateEmpresaGrupo(this.usuario)
        this.$emit('update')
      }
      catch(error)
      {
        console.error(error)
        this.$swal.error(error)
      }
      finally
      {
        this.loading = false
      }
    },

    async start() {
      try
      {
        this.papeis = await new Papeis().list()
        this.grupos = await new Grupos().list()
      }
      catch(error)
      {
        console.error(error)
        this.$swal.error(error)
      }
    },
  },

  mounted() {
    this.start()
  }
}
</script>
